import { useEffect } from 'react';

import * as moment from 'moment';
import { useSelector } from 'react-redux';

import { getCurrentPlanDisplayName, getIsInProfessionalPlan } from '~/selectors/plans.selectors';
import { getCurrentPromo } from '~/selectors/user.selectors';

import { type SetUserVariables } from './useFullStoryUserVars';

/**
 * Forwards user's plan to FullStory.
 */
export const useFullStoryBillingPlan = ({
  setUserVariables,
}: {
  setUserVariables: SetUserVariables;
}) => {
  const plan = useSelector(getCurrentPlanDisplayName);
  const isPro = useSelector(getIsInProfessionalPlan);
  const currentPromo = useSelector(getCurrentPromo);

  useEffect(() => {
    setUserVariables({
      isPro,
      plan,
      promoStartDate: moment.isMoment(currentPromo?.startDate)
        ? currentPromo?.startDate.toDate()
        : undefined,
    });
  }, [plan, isPro, currentPromo, setUserVariables]);
};
